import React from 'react';
import {
  NumberInput,
  TextInput,
  minValue,
  number,
  useTranslate,
} from 'react-admin';
import TableCell from '@material-ui/core/TableCell';
import { InputAdornment } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';

import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  root: {
    '& .MuiTextField-root': {
      width: '100%',
    },
    '& .MuiFilledInput-root': {
      backgroundColor: '#fdfdfd',
    },
    '& .MuiFormHelperText-contained': {
      display: 'none',
    },
  },
  listLabel: {
    fontWeight: '600',
    color: '#637381',
    marginTop: 20,
  },
  flexEnd: {
    alignItems: 'right',
    justifyContent: 'flex-end',
  },
  textRight: {
    textAlign: 'right',
  },
  discoutTextarea:{
    '& .MuiFilledInput-multiline.MuiFilledInput-marginDense':{
      padding:3
    },
    '& textarea':{
      height:'7px !important'
    },
    '& .MuiFilledInput-inputMultiline':{
      padding: '18px 12px'
    }
  }
}));

const UnifiedEditCustomDiscount = ({
  custom_discount_amount_dollars = null,
  showFormatted,
  handleDiscountReasonChange = () => {},
  handleDiscountAmountChange = () => {},
}) => {
  const classes = useStyles();
  const translate = useTranslate();
  return (
    <>
      <TableCell colSpan={3}></TableCell>
      <TableCell colSpan={9}>
        <Grid container spacing={1} className={classes.root}>
          <Grid item md={3} sm={3} xs={12}>
            <Typography
              variant="body1"
              gutterBottom
              className={classes.listLabel}
            >
              Custom Discount
            </Typography>
          </Grid>

          <Grid item md={9} sm={9} xs={12}>
            <Grid
              container
              spacing={1}
              className={`${classes.root} ${classes.flexEnd} schedule_work_section`}
            >
              <Grid item md={5} sm={5} xs={12}>
                <TextInput
                  multiline
                  source="custom_discount_reason"
                  label="Reason"
                  onBlur={handleDiscountReasonChange}
                  className={classes.discoutTextarea}
                />
              </Grid>
              <Grid item md={5} sm={5} xs={12}>
                <NumberInput
                  validate={[number(), minValue(0)]}
                  source="custom_discount_amount_dollars"
                  label=""
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">$</InputAdornment>
                    ),
                  }}
                  onBlur={handleDiscountAmountChange}
                />
              </Grid>
              {showFormatted && (
                <Grid item md={2} sm={2} xs={12} className={classes.textRight}>
                  {custom_discount_amount_dollars &&
                  custom_discount_amount_dollars > 0
                    ? `- $${custom_discount_amount_dollars.toFixed(2)}`
                    : ''}
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
      </TableCell>
    </>
  );
};

export default UnifiedEditCustomDiscount;
